import { useCallback } from 'react';
import { buildService } from './service';
import serviceMethods from './service_methods';
const api = buildService('/folder_files/{id}/user_access_file_participations', {
  only: ['create', 'update', 'delete']
});
const useDeleteUserAccessFileParticipationFromClaimGroup = (claimGroup, setClaimGroup, setLoading) => {
  const deleteParticipation = serviceMethods.useDelete({
    callback: useCallback(async (selectedUserAccess, participation, folderFileId) => {
      await api.delete(folderFileId, participation.id);
      const userAccessInClaimGroup = claimGroup.user_accesses.find(userAccess => userAccess.id === selectedUserAccess.id);
      userAccessInClaimGroup.user_access_file_participations = userAccessInClaimGroup.user_access_file_participations.filter(existingParticipation => existingParticipation.id !== participation.id);
      setClaimGroup({
        ...claimGroup
      });
    }, [claimGroup, setClaimGroup]),
    setLoading
  });
  return deleteParticipation;
};
const useCreateUserAccessFileParticipationFromClaimGroup = (claimGroup, setClaimGroup, setLoading) => {
  const createParticipation = serviceMethods.useCreate({
    callback: useCallback(async (selectedUserAccess, folderFileId) => {
      const newParticipation = await api.create(folderFileId, {
        user_access_id: selectedUserAccess.id
      });
      const userAccessInClaimGroup = claimGroup.user_accesses.find(userAccess => userAccess.id === selectedUserAccess.id);
      userAccessInClaimGroup.user_access_file_participations ||= [];
      userAccessInClaimGroup.user_access_file_participations.push(newParticipation);
      setClaimGroup({
        ...claimGroup
      });
      return newParticipation;
    }, [claimGroup, setClaimGroup]),
    setLoading
  });
  return createParticipation;
};
const useUpdate = (claimGroup, setClaimGroup) => {
  const update = serviceMethods.useUpdate({
    callback: useCallback(async _ref => {
      let {
        user_access_file_participation
      } = _ref;
      const updated = await api.update(user_access_file_participation.folder_file_id, user_access_file_participation.id, {
        user_access_file_participation
      });
      const userAccessInClaimGroup = claimGroup.user_accesses.find(userAccess => userAccess.id === updated.user_access_id);
      const index = userAccessInClaimGroup.user_access_file_participations.findIndex(participation => participation.id === updated.id);
      userAccessInClaimGroup.user_access_file_participations[index] = updated;
      setClaimGroup({
        ...claimGroup
      });
      return updated;
    }, [claimGroup, setClaimGroup])
  });
  return update;
};
const userAccessFileParticipationsService = {
  useDeleteUserAccessFileParticipationFromClaimGroup,
  useCreateUserAccessFileParticipationFromClaimGroup,
  useUpdate
};
export default userAccessFileParticipationsService;